// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_auth_auth_module_ts":"27d16e88fb20747b","src_app_layout_dashboard_dashboard_module_ts":"198f1f49f73a70fd","src_app_container_index_ts":"572d296ae673f760"}[chunkId] + ".js";
};